import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/account/audit-log')({
  component: () => <Outlet />,
});
